import { useState } from "react";
import { useAction } from "convex/react";
import { api } from "../lib/convexApi";

// Spec 7: upgrading to Security is a Lemon Squeezy tier change on the org's
// existing subscription (changeTier action), NOT the removed Clerk Billing
// plans page. The subscription_updated webhook flips the tier and the
// reactive useEntitlements() gate re-renders — so this prompt disappears with
// no manual refresh. changeTier is admin-gated (re-prices the whole
// workspace); personal workspaces auto-promote to admin, so solo devs are
// unaffected. Non-admin members get a clear "ask an admin" message.
export function SecurityUpgradePrompt() {
  const changeTier = useAction(api.billing.checkout.changeTier);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function handleUpgrade() {
    setBusy(true);
    setErr(null);
    try {
      await changeTier({ tier: "security" });
      // Deliberately leave busy=true on success (Gemini): the tier change only
      // takes visible effect once the subscription_updated webhook propagates
      // and the reactive useEntitlements() gate re-renders this prompt away.
      // Resetting busy here would re-enable the button during that window and
      // let an impatient user fire a duplicate changeTier. busy resets only on
      // error (below), where the prompt stays mounted.
    } catch {
      setErr(
        "Could not upgrade to Ultra Security. If you are not a workspace admin, ask an admin to upgrade."
      );
      setBusy(false);
    }
  }

  return (
    <div className="security-upgrade-prompt">
      <div className="security-upgrade-prompt__card">
        <h1>Security features require the Ultra Security plan</h1>
        <p>
          The Security Room, policy engine, DLP detection, memory graph, and approval workflows are
          on the Ultra Security tier ($100/mo).
        </p>
        <button
          type="button"
          className="security-upgrade-prompt__cta"
          disabled={busy}
          onClick={handleUpgrade}
        >
          Upgrade to Ultra Security
        </button>
        {err && (
          <p className="security-upgrade-prompt__error" role="alert">
            {err}
          </p>
        )}
      </div>
    </div>
  );
}
